import ManageEventPartners from "./ManageEventPartners";
export default ManageEventPartners;
